export const DEFAULT_BRAND = '#059669';
export const BRAND_PRESETS = [
  ['#059669', 'Verde BioPraga'], ['#0d9488', 'Turquesa'], ['#0284c7', 'Azul'], ['#4f46e5', 'Índigo'],
  ['#ea580c', 'Laranja'], ['#be123c', 'Vinho'], ['#475569', 'Grafite'],
];
const EMERALD = { 50: '236 253 245', 100: '209 250 229', 200: '167 243 208', 300: '110 231 183', 400: '52 211 153', 500: '16 185 129', 600: '5 150 105', 700: '4 120 87', 800: '6 95 70', 900: '6 78 59', 950: '2 44 34' };
const LIGHT = { 50: 97, 100: 93, 200: 86, 300: 76, 400: 62, 500: 48, 700: 30, 800: 24, 900: 19, 950: 11 };

const hexToHsl = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(v => v / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  if (max === min) return [0, 0, l * 100];
  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  const h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return [h * 60, s * 100, l * 100];
};
const hslToRgb = (h, s, l) => {
  s /= 100; l /= 100;
  const k = (n) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n) => Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));
  return `${f(0)} ${f(8)} ${f(4)}`;
};
const hexRgb = (hex) => { const n = parseInt(hex.slice(1), 16); return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`; };

// Gera a escala 50–950 a partir da cor principal (tom 600).
export function brandPalette(hex) {
  if (!hex || hex.toLowerCase() === DEFAULT_BRAND) return EMERALD;
  const [h, s] = hexToHsl(hex);
  const out = { 600: hexRgb(hex) };
  Object.entries(LIGHT).forEach(([k, l]) => { out[k] = hslToRgb(h, Math.min(s, k <= 200 ? 80 : 95), l); });
  return out;
}

export function applyAppearance(a = {}) {
  const root = document.documentElement;
  Object.entries(brandPalette(a.brand_color)).forEach(([k, v]) => root.style.setProperty(`--brand-${k}`, v));
  const dark = a.theme === 'dark' || (a.theme === 'system' && window.matchMedia?.('(prefers-color-scheme: dark)').matches);
  root.classList.toggle('dark', !!dark);
  const el = document.getElementById('root');
  if (el) el.style.zoom = a.font_scale && a.font_scale !== 100 ? String(a.font_scale / 100) : '';
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', a.brand_color || DEFAULT_BRAND);
}
